export const common = {
  '请求延时': 'リクエスト遅延',
  '操作成功': '操作成功',
  '暂无数据': 'データがありません',
  '请输入': '入力してください',
  'copyok': 'コピー成功',
  'copyerror': 'コピー失敗',
};

export const tableList = {
  '跟单交易量':'取引量のコピー',
  '跟单总交易量':'コピー取引総量',
  用户昵称: "ユーザーのニックネーム",
  '持仓': 'ポジション',
  '仓位': 'ポジション',
  '当前委托': '現在の注文',
  '当前计划': '現在の計画',
  '历史仓位': '過去のポジション',
  '账单': '財務履歴',
  '全部平仓': '全ポジションを清算',
  '全部撤单': 'すべてをキャンセル',
  
  '合约名称': '先物名',
  '创建时间': '作成日時',
  '方向': '方向',
  '杠杆': 'レバレッジ',
  '保证金': '証拠金',
  '开仓价格': 'ポジション取得価格',
  '开仓均价': 'ポジション取得平均価格',
  '全仓风险率': '全ポジションリスク率',
  '预估爆仓价': '予想ロスカット価格',
  '收益率': '収益率',
  '平仓价格': '清算価格',
  '预计强平价': '予想強制清算価格',
  '持仓数量': 'ポジション数',
  '张': '枚',
  风险率: 'リスク率',
  保证金率: '証拠金率',
  预计止盈价: '予想利確価格',
  预计止损价: '予想損切り価格',
  浮动盈亏: '浮動損益',
  平仓盈亏: '清算損益',
  盈亏: '損益',
  委托数量: '注文数量',
  委托价格: '注文価格',
  成交价格: '成約価格',
  成交均价: '成約平均価格',
  止盈价: '利確価格',
  止损价: '損切り価格',
  执行价: '実行価格',
  触发条件: 'トリガー条件',
  操作: '操作',
  手续费: '手数料',
  平仓类型: '決済タイプ',
  类型: 'タイプ',
  数量: '数量',
  
  逐仓做多: '分離ロング',
  逐仓做空: '分離ショート',
  全仓做多: 'クロスロング',
  全仓做空: 'クロスショート',
  永续合约: '無期限先物',
  
  手动平仓: '手動清算',
  市价平仓: '市場価格で清算',
  限价平仓: '指値で清算',
  止盈: '利確',
  止损: '損切り',
  手动撤销: '手動キャンセル',
  自动减仓: '自動ポジション削減',
  强制减仓: '強制ポジション削減',
  强制平仓: '強制清算',
  资金不足系统撤单: '資金不足のためシステムキャンセル',
  资金超限系统撤单: '資金制限超過のためシステムキャンセル',
  撤单: 'キャンセル',
  平仓: '清算',
  更多: 'もっと見る',
  部分平仓: '一部清算',
  反向开仓: '反対ポジション取得',
  加仓: 'ポジション追加',
  一键平仓: '一括清算',
  最新价: '最新価格',
  体验金平仓: '24時間以内の清算',
  下单时间: '注文日時',
  交易类型: '取引タイプ',
  委托类型: '注文タイプ',
  成交类型: '成約タイプ',
  逐仓平多: '分離ロング清算',
  逐仓开多: '分離新規ロング',
  逐仓平空: '分離ショート清算',
  逐仓开空: '分離新規ショート',
  全仓平多: 'クロスロング清算',
  全仓开多: 'クロス新規ロング',
  全仓平空: 'クロスショート清算',
  全仓开空: 'クロス新規ショート',
  可平量为0: '清算可能数量が0です',
  激活价格: 'アクティベーション価格',
  状态: 'ステータス',
  未激活: 'アクティベート待ち',
  已激活: 'アクティベート済み',
  回调率: 'リトレースメント率',
  仓位ID: 'ポジションID',
  
};
export const dialog = {
  前往设置: '設定に移動',
 提示: 'お知らせ',
 确定: '確定',
 取消: 'キャンセル',
 确认要全部平仓吗: '市場価格ですべてのポジションを清算し、すべての注文をキャンセルしますか？',
 确认要全部撤单吗: 'すべての注文をキャンセルしますか？',
 确认要一键平仓吗: '一括清算しますか？',
 确认要一键平仓: '一括清算し、コピートレードを解除しますか？',
 确认要市价平仓吗: '市場価格で清算しますか？',
 确认要限价平仓吗: '指値で清算しますか？',
 需先设置总跟单账户: 'コピートレードを開始するには、まずコビートレード口座を設定してください。',
 加仓: 'ポジション追加',
 不能为空: '入力してください',
 必须为数字值: '数字を入力してください',
 数字不能小于等于0: '0以下の数字は入力できません',
 请输入正确的杠杆倍数: '正しいレバレッジ倍数を入力してください',
 无法切换仓位模式: 'ポジションモードを切り替えることができません',
 当前账户没有权限: '現在の口座は権限がありません',
 swap001: '現在ポジションを保持しているため、ポジションモードを切り替えることができません',
 需全部平仓后可重新设置: 'ポジションをすべて清算してから、トレード額や倍率を再設定できます。',
 按张数: '枚数で',
 按金额: '金額で',
 按比例: '割合で',
 按价格: '価格で',
 张: '枚',
 预计加仓金额: '予想ポジション追加金額',
 预计加仓张数: '予想ポジション追加枚数',
 持仓数量: 'ポジション数',
 开仓价格: 'ポジション取得価格',
 确认要反向开仓吗: '逆方向に新規ポジション取得しますか？',
 预计平仓金额: '予想清算金額',
 预计平仓比例: '予想清算割合',
 预计平仓张数: '予想清算枚数',
 比例不可以大于: '割合は最大値を超えることはできません',
 比例不可以小于: '割合は最小値を下回ることはできません',
 部分平仓: '一部清算',
 确认撤单吗: 'キャンセルしますか？',
 确认要平仓吗: '清算しますか？',
 盈亏: '損益',
 当前止损价: '現在の損切り価格',
 预估止损价: '予想損切り価格',
 亏损: '損失',
 止损修改: '損切り修正',
 止损比例: '損切り割合',
 止损价格: '損切り価格',
 当前盈利价: '現在の利益価格',
 预估止盈价: '予想利確価格',
 收益: '収益',
 止盈修改: '利確修正',
 止盈比例: '利確割合',
 止盈价格: '利確価格',
 请输入加仓数: '追加ポジション数を入力してください',
 请输入金额: '金額を入力してください',
 请输入止盈价格: '利確価格を入力してください',
 请输入止盈比例: '利確割合を入力してください',
 请输入止损价格: '損切り価格を入力してください',
 请输入止损比例: '損切り割合を入力してください',
 
 'BTC/USDT账户模式': 'BTC/USDT 口座モード',
 账户模式: '口座モード',
 调整仓位模式: 'ポジションモードを調整',
 保证金模式: '保証金モード',
 仓位模式: 'ポジションモード',
 调整保证金模式: '保証金モードを調整（全てのUSDT先物に適用）',
 调整仓位合并模式: 'ポジションモードを調整（全てのUSDT先物に適用）',
 全仓模式: 'クロスポジションモード',
 仓位合并: 'ポジション統合',
 逐仓: '分離ポジション',
 全仓: 'クロスポジション',
 合仓: 'ポジション合併',
 分仓: 'ポジション分割',
 swap002:
 '分離モードでは、ユーザーは両建てを持つことができ、ショートとロングのリスクは個別に計算されます。強制清算はユーザーの自分のポジション証拠金だけを失います。ユーザーがポジションを手動で決済すると、ショートとロングが別々に損失と利益を生じ、即座に対応するポジションの証拠金に計上されます。',
 全仓模式下所有仓位将共享合约账户的可用保证金:
 'クロスモードでは、全てのポジションは先物口座の利用可能な証拠金を共有し、強制清算が発生すると、すべてのポジションと利用可能な証拠金が失われる可能性があります。リスクに注意してください。',
 合仓提示: '',
 分仓提示: '',
 不再提示: '今後は表示しない（設定から再表示できます）',
 
 biking合约用户使用协议: 'Biking先物ユーザー利用規約',
 综述:
 '<b>1.概要</b><br><br>' +
 '<span>' +
 '1.1 無期限先物（以下「本サービス」）は、「Biking」がサービスを提供するデジタル資産デリバティブです。商品の設計および管理と取引プラットフォームの運営サービスはすべて「Biking」が担当します。' +
 '無期限先物を使用するためには、「Biking」無期限先物ユーザー使用規約（以下「本規約」）をお読みいただき、そのすべての条項に従って利用する必要があります。各条項内容を慎重にお読みいただき、理解した上で承諾または不承諾を選択してください。' +
 '<br><br>' +
 '1.2 本規約の全ての条項をお読みいただき、すべての条項に同意しない場合は、本サービスを利用する権利がありません。本規約の条項を承諾し、本サービスの利用した場合は、本規約の拘束力を受け入れたことを意味します。' +
 '</span>' +
 '<br><br>' +
 '<b>2.本サービスの利用資格</b>' +
 '<br><br>' +
 '<span>2.1 あなたは、以下を理解し、確認します：' +
 '<br>' +
 '「Bikingサービス規約」に同意したうえで「サービス」を使用する権利を有しており、また、同規約が定義する「サービス」の使用が禁止されていない場合。' +
 '<br>' +
 '本規約は、所在国または地域の法律に抵触しない場合。' +
 '<br>' +
 'あなたは、本サービスへのデジタル資産の資金元が合法であることを確認し、また、そのデジタル資産の取得方法が合法であることを保証できる場合。' +
 '<br><br>' +
 '2.2 あなたは、以下のリスクを理解します。これらには限定されないが、以下が含まれます：' +
 '<br>' +
 'デジタル資産およびそのデリバティブは価格変動が激しく、短時間で大幅な損失、またはすべてのデジタル資産の損失を引き起こす可能性があります。' +
 '</span>',
 我已阅读并同意上述协议: '上記の規約を読み、同意しました',
 
 调整杠杆: 'レバレッジを調整',
 杠杆倍数: 'レバレッジ倍数',
 当前杠杆倍数最大可开: '現在のレバレッジ倍数で可能な最大ポジション数：',
 '当前仓位所需保证金：': '現在のポジションに必要な証拠金：',
 
 交易单位切换: '取引単位の切り替え',
 成交类型切换: '約定タイプの切り替え',
 限价: '指値',
 市价: '成行',
 数字范围必须在: '数字の範囲は1から100までです',
 请输入平仓数: '清算する数量を入力してください',
 请输入平仓比例: '清算割合を入力してください',
 请输入整数: '整数を入力してください',
 以当前最优价格交易: '現在の最適価格で取引',
 请输入格式正确的杠杆倍数: '正しいフォーマットのレバレッジ倍数を入力してください',
 杠杆倍数提示: '現在のレバレッジ倍数が高いため、リスクに注意してください。',
 下单二次确认: '注文二次確認',
 平仓二次确认: '清算確認',
 下单确认: '注文確認',
 二次确认不展示: '次回から表示しない（設定で再表示可能）',
 切换交易单位: '取引単位の切り替え',
 偏好设置: 'お好みの設定',
 仓位止盈止损: 'ポジション利確損切り',
 移动止盈止损: '移動利確損切り',
 止盈止损提示:
 '移動利確損切り修正は、ポジション清算に使用されます。これは、市場が良い方向に進行している場合に、トレーダーの利益を保護するために使用されるストップオーダー戦略です。市場価格がアクティベーション価格に達すると、注文がアクティブ化されます。市場価格がトレーダーが設定した戦略の最高（または最低）価格の（1±反落率）に達すると、注文がトリガされ、実行価格は最高（または最低）価格の（1±反落率）になります。',
 最新成交价: '最新成約価格',
 设置止盈: '利確設定',
 设置止损: '損切り設定',
 预计盈利: '予想利益',
 预计亏损: '予想損失',
 调整保证金: '証拠金のを調整',
 增加: '増やす',
 减少: '減らす',
 最大: '最大',
 当前仓位保证金: '現在のポジション証拠金',
 最大可增加: '最大増加可能額',
 最大可减少: '最大減少可能額',
 调整后参考强评价: '証拠金調整後の清算価格',
 请输入保证金: '証拠金を入力してください',
 强平价格: '強制清算価格',
 开仓数量: 'ポジション取得数量',
 计算: '計算',
 计算结果: '計算結果は参考値です',
 回调率: 'リトレースメント率',
 请输入回调率: 'リトレースメント率を入力してください',
 仓位数量: 'ポジション数量',
 激活价: 'アクティベーション価格',
 请输入激活价: 'アクティベーション価格を入力してください',
 激活做多提示: 'ロング方向は最新成約価格より高い価格を設定してください',
 激活做空提示: 'ショート方向は最新成約価格より低い価格を設定してください',
  
};
export const codeInfo = {
  永续合约: '無期限',
  标记价格: 'マーク価格',
  指数价格: '指数価格',
  指数价格提示:
  'この先物のリアルタイムの指数価格。この価格は、ユーザーの保有するポジションの予測ロスカット価格の計算に参加しますが、先物の最新取引価格とは異なる場合があります。価格操作を避けるためのものです。',
  '24H最高': '24時間の最高価格',
  '24H最低': '24時間の最低価格',
  资金费率: '本期ファンディングレート',
  距费用结算: '次のファンディングレート精算まで',
  我的赠金: '私のボーナス',
  };
  export const panKou = {
    交易深度: '板',
    实时成交: '約定履歴',
    张: '枚',
    保证金: '証拠金',
    价格: '価格',
    数量: '数量',
    时间: '時間',
    累计: '累計',
  };
  export const placeOrder = {
    立即去玩:"すぐに始める",
    全仓: 'クロス',
 逐仓: '分離',
 杠杆: 'レバレッジ',
 开多: 'ロング',
 开空: 'ショート',
 市价委托: '成行注文',
 限价委托: '指値注文',
 计划委托: 'トリガー注文',
 价格: '価格',
 数量: '数量',
 限价: '指値',
 市价: '成行',
 止盈止损: '利確損切',
 张: '枚',
 开仓价: 'ポジション取得価格',
 触发价: 'トリガー価格',
 执行价: '実行価格',
  
 收益: '利益',
 按比例设置: '割合で設定',
 按价格设置: '価格で設定',
 亏损: '損失',
  
 swap003: '買い/ロング',
 swap004: '売り/ショート',
 买入: '買い',
 卖出: '売り',
 做多: 'ロング',
 做空: 'ショート',
 可用: '利用可能',
 可做多: 'ロング可能',
 可做空: 'ショート可能',
  
 资产: '資産',
 持仓保证金: 'ポジション証拠金',
 未实现盈亏: '含み損益',
 净值: '純価値',
 可用保证金: '利用可能な証拠金',
 账户余额: '口座残高',
 风险率: 'リスク率',
  
 合约信息: '先物情報',
 指数来源: '指数の情報源',
 合约面值: '先物価値',
 资金费率: 'ファンディングレート',
 最大杠杆: '最大レバレッジ',
 下单方向可开张数の: '注文方向の利用可能枚数の',
  
 立即注册: '新規登録',
 登录: 'ログイン',
 swap005: '資産（無期限先物）',
 登录以查看: 'ログインして表示',
  
 请输入数量: '数量を入力してください',
 请输入价格: '価格を入力してください',
 请输入限价: '指値価格を入力してください',
 请输入止盈止损: '利確損切を入力してください',
 '止损率不能大于90%': '損切率は90%を超えることはできません',
 止损价格不能大于: '損切価格は上限を超えることはできません',
 开通合约账号: '先物口座を開設',
 账号冻结: '口座が凍結されています',
 '止盈率不能大于1000%': '利確率は1000%を超えることはできません',
 请输入触发价: 'トリガー価格を入力してください',
 保证金: '証拠金',
 体验金: '体験ボーナス',
 不使用体验金: '体験ボーナスを使用しない',
 查看详情: '詳細を表示',
 委托保证金: '注文証拠金',
 币: '通貨',
 计算器: '電卓',
 划转: '振替'

  };
  export const codelist = {
    搜索: '検索',
    全部: '全て',
    交易对: '取引ペア',
    最新价: '最新価格',
    涨幅: '上げ幅',
    自选: 'お気に入り',
    添加自选成功: 'お気に入りに追加しました',
    取消自选成功: 'お気に入りから削除しました',
  };
  export const merchandiser = {
    我的实盘: "私の実際の取引",
 与优秀的交易员共同赚钱: "優れたトレーダーと一緒に稼ぐ",
 code_00051: "コピー取引コミュニティ",
 个人中心: "マイページ",
 更多服务: "その他のサービス",
 钱包: "ウォレット",
 衍生品: "デリバティブ",
 跟单设置: "コピー取引設定",
 跟单: "コピー取引",
 跟单提示: "データは毎時間更新されます",
 我的跟单: "私のコピー取引",
 成为交易员: "トレーダーになる",
 综合排名: "総合ランキング",
 收益率: "収益率",
 近3周收益: "過去3週間の収益",
 近3周胜率: "過去3週間の勝率",
 总收益: "総収益",
 累计收益率: "累計収益率",
 累计跟随人数: "累計フォロワー数",
 跟随中: "コピー取引中",
 AUM: "AUM（資産管理総額）",
 当前跟谁: "現在コピー中のトレーダー",
 搜索交易员: "トレーダーを検索",
 满员: "満員",
 申请成为交易员: "トレーダー資格申請",
 手机号: "電話番号",
 邮箱: "メールアドレス",
 请输入邮箱: "メールアドレスを入力してください",
 邮箱错误: "正しいメールアドレスを入力してください",
 请输入手机号: "電話番号を入力してください",
 手机号错误: "正しい電話番号を入力してください",
 请输入正确数值: "正しい値を入力してください",
 申请交易员提示文案: "トレーダーになって、フォロアップで収益を分ける",
 跟单确认: "コピートレードを確認",
 我已同意跟单协议: "私はコピー取引規約を読み、同意します",
 跟单协议: "《コピートレード規約》",
 申请跟单提示文案: "本規約は、あなた（以下、「お客様」または「お客様の」）とビーキングとの間で締結されます。お客様がビーキングプラットフォームまたはその他の関連サービス（以下、「本サービス」）にアクセスし、利用する際には、本使用規約に同意し、これに従うものとします。本規約は、お客様の個人情報の取り扱いについても適用されるため、本プラットフォームに公開されているプライバシーポリシーも合わせてご確認ください。",
 申请跟单提示文案1: "1.トレーダーとコビートレードをすることで、損失を生じるリスクがあります。このリスクはコビートレードを行うお客様の自身が負担します。",
申请跟单提示文案2: "2.ビーキングプラットフォームは分離モードでのコビートレードを対応しております、もしユーザーが自主的に先物取引をする場合は先物口座で先物取引を始めることができます。その期間中にコビートレード口座への影響はありません。",
申请跟单提示文案3: "3.コビー成功後、トレーダーが新しく取得したポジションのみコビーできます、既に取得済みのポジションに対してはコビーできません。コビートレードの取り消しは随時できますが、コビートレードの取り消しにより、コビートレード中に取得したポジションに対して清算することはありません。手動での操作は可能です。",
申请跟单提示文案4: "4.コビートレード中に、コビーポジションに対して調整を行った場合、コビートレードが中断することになります。",
申请跟单提示文案5: "5.コビートレードを清算して、利益が出た場合、該当するフォロアップの12%の利益はトレーダーへの報酬として差し引かれます。",
申请跟单提示文案6: "6.トレーダーとのコビートレードは損失が出るリスクが伴いますリスクコントロールを考慮しながら、。慎重に検討してください。",
申请跟单提示文案7: "7.コビートレード中にトレーダーが不正取引を行ったと判断された場合は、トレーダー資格が剝奪されます。",
申请跟单提示文案8: "8.トレーダーはコビートレード中のユーザーを削除することができます。トレーダーに削除されたら新しいポジションを取得することはできません。既にコビートレードしたポジションへの影響はありません。",
搜索您的国家名或国家区号: "国名または国番号を検索",
我已同意成为交易员: "私はトレーダーになることを同意しました",
请勾选: "チェックしてください",
申请交易员失败提示: "現在はコビートレード中のため、トレーダーになる申請は提出できません。全てのコビートレードを停止してから、再度申請してください。",
我知道了: "分かりました",
今日收益: "今日の利益",
累计收益: "累計利益",
交易员分成: "トレーダーの分配",
待结算分成: "精算済の分配",
已结算分成: "精算済みの分配",
当前跟单: "現在のコビートレード",
历史跟单: "過去のコビートレード",
我的交易员: "私のトレーダー",
编辑: "編集",
平仓均价: "平均清算価格",
持仓均价: "平均ポジション価格",
开仓时间: "ポジション取得時間",
平仓时间: "清算時間",
预估暴仓价: "予想ロスカット価格",
交易员: "トレーダー",
详情: "詳細",
仓位ID: "ポジションID",
空位提醒: "空席通知",
空位提醒内容: "このトレーダーのフォロワー人数が既に満員になっております。トレーダーが満員でない場合に通知を1回送信します。",
当前跟随: "現在のフォロー",
跟随人数数据: "{v1}/{v2}人",
跟随人数: "フォロワー人数",
总权益: "総資産",
带单合约: "フォロアップ先物",
交易数据: "取引データ",
交易笔数: "取引回数",
盈利笔数: "利確回数",
亏损笔数: "損失回数",
扛单比例: "塩漬け率",
平均扛单率: "平均塩漬け率",
最大扛单率: "最大塩漬け率",
订单: "注文",
跟随者: "フォロワー",
跟随者收益: "フォロワーの収益",
跟随用户: "フォローするユーザー",
跟随总额: "フォロー総額",
跟随收益: "フォロー収益",
交易员订单本金: "トレーダー注文元本",
当前带单: "現在のフォロアップ",
历史带单: "過去のフォロアップ",
跟单数据统计: 'コピー取引統計',
不用了: "不要です",
设置提醒成功: "通知の設定が成功しました",
我的带单: "私のフォロアップ",
查看主页: "プロフィールを見る",
利润分成比例: "利益分配率",
跟随交易员: "トレーダーをフォロー",
仓位类型: "ポジションタイプ",
指定杠杆: "指定レバレッジ",
请输入杠杆: "レバレッジを入力してください",
单笔倍率: "1回の注文の倍率",
单笔金额: "1回の注文金額",
固定额度: "固定額",
请输入单笔金额1: "5U以上の固定金額を入力してください",
请输入单笔金额: "{v1}〜{v2}で1回の注文金額を入力してください",
请输入单笔倍率: "{v1}〜{v2}のコビー比率を入力してください",
每次下单折合U: "各新規ポジション取得の証拠金は、{v1}USDT相当です",
每次下单倍数: "各注文の数量は、トレーダーの注文数量の{v1}倍です",
倍率: "倍率",
跟单本金: "コビートレード元本",
总跟单保证金: "総コビー証拠金",
请输入跟单本金: "コビートレード元本を入力してください",
资产账户: "資産口座{v1}USDT",
合约账户: "先物口座{v1}USDT",
风险控制: "リスクコントロール",
设置: "設定",
保存: "保存",
取消跟随: "コビーをキャンセル",
移除跟随: "コビーを削除",
交易员保证金: "トレーダーの証拠金",
请输入交易员保证金: "トレーダーの証拠金を入力してください",
风险设置提示: "このトレーダーの保有元本がこの数値に達した場合、以降の注文はコビーできなくなります",
关闭带单: "フォロアップを終了",
我的跟随者: "私のフォロワー",
带单设置: "フォロアップ設定",
预计利润分成: "予想利益分配",
利润分成: "利益分配",
开启成功: "開始しました",
开启失败: "開始が失敗しました",
关闭成功: "終了しました",
关闭失败: "終了が失敗しました",
确认取消吗: "コビートレードをキャンセルしますか？",
条件一: "先物ポジションなし、現在の注文、トリガー注文",
条件二: "先物口座利用可能残高>={v}USDT",
条件三: "先物ポジションなし",
最大回撤: "最大ドローダウン",
平均持仓时间: "平均ポジション保有時間",
正在跟随: "コビートレード中",
历史跟随: "過去のコビートレード",
累计跟单: "累計コビートレード",
累计分成: "累計分配",
笔: "回",
上一页: "前へ",
下一页: "次へ",
返回: "戻る",
今日预估收益: "今日の予想利益",
账户权益: "口座資産",
将账户权益展示在个人信息页面: "口座資産を個人情報ページに表示されます",
带单本金: "フォロアップ元本",
每次开仓均会展示带单本金: "毎回のポジション取得時はフォロアップ元本が表示されます",
隐藏挂单价:'未決注文価格を非表示にする',
带单币对: "フォロアップコインペア",
入住时间: "登録日",
保存成功: "保存が成功しました",
取消成功: "キャンセルが成功しました",
设置成功: "設定が成功しました",
跟单合约: "先物コビートレード",
历史委托: "過去の注文",
成交数量: "成約数量",
触发时间: "トリガー時間",
开启带单: "フォロアップを開始",
账户已冻结: "口座が凍結されました。カスタマーサポートにお問い合わせください",
审核中: "審査中",
小时: "{v}時間",
累计分润: "累計利益",
今日预估分润: "今日の予想利益",
交易协议: "取引規約",
带单协议: "フォロアップ規約",
追加跟单本金: "コビー元本を追加",
提示: "注意：",
提示信息: "利益の分配は毎日0時に計算され、1時までに完了します。計算後、利益は自動的に先物口座に送金されます。分配期間中にフォロアップ元本を持っている場合、次の取引日に収益が計算されます",
合约跟单: "先物コビートレード",
跟单文字: "Bikingで、世界トップクラスのトレーダーと一緒にお金を稼ぎましょう",
查看牛人实盘: "トップトレーダーの実績を見る",
捕捉市场信号: "市場のシグナルをキャッチする",
复制高手收益: "エキスパートの収益をコピーする",
跟单指南: "コビートレードガイド",
跟单广场: "コビートレードスクエア",
跟单总收益: "総コビー利益",
丰厚分润收入: "豊富な収益",
更多平台曝光: "さらに多くのプラットフォームの露出率",
专属交易徽章: "専用のトレードバッジ",
成为Biking带单交易员: "ワンステップでBikingのコビートレーダーになる",
享受Biking带单交易员的独家福利: "Bikingのコビートレーダー専用の独占特典をお楽しみください",
平台奖励: "12%のフォロアップ収益をお楽しみください",
联系方式: "連絡先",
简介: "プロフィール",
请输入简介: "プロフィールを入力してください",
交易能力证明: "取引能力証明（オプション）",
选择周期: "30日以上の収益率曲線、取引データ統計などを含むスクリーンショットを選択してください。アップロードは最大3枚で、1枚のサイズは10MBを超えないようにしてください。",
我已阅读并同意: "私は内容を確認し、同意します",
跟单交易服务条款: "《コビートレードサービス規約》",
立即申请: "今すぐ申請",
请输入联系方式: "連絡先を入力してください",
联系方式不正确: "連絡先は正しくありません",
邮箱格式不正确: "メールアドレスのフォーマットが正しくありません",
请输入简介信息: "プロフィールを入力してください",
请确认勾选协议: "規約を同意するにはチェックしてください",
上传头像图片限制: "アップロードされるプロフィール画像のサイズは10MBを超えてはいけません",
最大限制: "現在の最大制限は3つのファイルをアップロードできます",
带单交易员招募中: "フォロアップトレーダー募集中、12%のコビートレード収益を即座にお楽しみください",
跟单成功: "コビー成功",
昵称: "ニックネーム",
请输入昵称: "ニックネームを入力してください",
申请交易员已提交: "コビートレードトレーダー申請を提出しました。審査中です"

};
export const hyy = {
   bkt: "開通しない",
 wqdkt: "開通することを確認",
 kt12: "1. この取引に参加する前に、仮想通貨デリバティブ取引の基本知識、関連するリスク、およびデリバティブ取引の取引ルールなどについて詳しく理解してください。",
 kt13: "2. 上記のリスク事項は列挙的なものであり、仮想通貨デリバティブ取引のすべてのリスク要因が詳細に挙げられているわけではありません。投資家が仮想通貨デリバティブ取引に参加する前に、他のリスク要因についても理解し、把握する必要があります。",
 kt14: "3. 投資家の皆様に、リスクを受け入れる能力など自身の実際の状況に基づいて、この契約取引に参加するかどうかを慎重に決定し、自身の仮想通貨を適切に配置していただくよう、お願いいたします。",
 kt0: "尊敬なるユーザー様へ：",
 kt1: "まだ先物口座および先物取引の権限を開設されていない方へ：以下の内容をよくご確認の上、開設のご判断をお願いいたします。",
 kt2: "一、先物市場で取引を行う際には、市場価格の動向が不利で、ポジションの証拠金が不足する場合、BiKing無期限先物はシステムで規定された通りに、ポジションの強制清算を委託し、強制清算の詳細を公開いたします。",
 kt3: "二、BiKing無期限先物の取引ルールを注意深く読み、遵守し、先物のメカニズムと動作原理を理解し、市場のさまざまなリスクを理解していただく必要があります。",
 kt4: "四、BiKing無期限先物は先物取引システムにアクセスしており、ユーザーのポジションの損益は先物市場の変動によって変化します。大きな損失が発生する場合、先物取引システム内で清算が発生する可能性があります。ユーザーは先物市場の変動に応じて適切な取引行動を自己判断し、損益を負担していただくことになります。したがって、BiKingはいかなる推定または確定された保証責任も負いません。",
 kt5: "五、極端な市場状況下では、保有している未清算先物を清算するのが難しい、または清算できない場合があります。たとえば、あなたの利益が全体の先物市場内で有効なレバレッジPnLの一位に位置し、相手方が保険基金でその積み倒し損失を補填するための資金が不足している場合です。",
 kt6: "六、仮想通貨デリバティブ取引は、特定の法律の政策監督リスクに直面する可能性があります。取引を行う前に、取引地域の政策監督背景をよく理解した上で慎重に判断していただく必要があります。関連する国または地域の法律、法令、政策の変更、先物取引所の取引ルールの変更、緊急措置の発表などの理由で、BiKingは事前に声明を発表する場合があります。保有している未清算先物を継続できない可能性がありますが、証拠金と利益の残高は引き続き清算されます。",
 kt7: "七、地震、水害、火災などの不可抗力要因、またはコンピューターシステム、通信システムの障害など、プラットフォームが制御できない要因により、ご指示が約定されないか、または一部のみ約定されない可能性があります。これにより生じる損失は、ご自身で負担いただく可能性があります。",
 kt8: "八、「ヘッジ取引」は投機取引と同様に、価格の変動によるリスクがあります。",
 kta9: "九、本人認証を行っていない場合やGoogle認証を登録していない場合、またはアカウントを他人に貸し出す場合、先物の証拠金の安全性が損なわれる可能性があります。",
 kta10: "三、極端な市場状況下では、保有している未清算先物を清算するのが難しい、またはできない場合があります。たとえば、あなたの利益が全体の契約市場内で有効なレバレッジPnLの一位に位置し、相手方が保険基金でその積み倒し損失を補填するための資金が不足している場合です。",
 kt9: "私は注意深く内容を確認し、リスクを受け入れます。",
 kt10: "先物口座および先物取引の権限を開設する",
 zjhz: "資金振替",
 ljhz: "すぐに振替",
 qx: "キャンセル",
 khz: "振替可能",
 qxz: "選択してください",
 bz: "通貨",
 c: "から",
 zz: "振替先",
 sl: "数量",
 qb: "すべて",
 ktcg: "開設成功",
 ktsb: "開設失敗",
 hzcg: "振替成功",
 hzsb: "振替失敗",
 wyyd: "", //未チェックの既読テキスト
 tc: "終了",
 warning1: "通貨を選択してください",
 warning2: "振替元アカウントを入力してください",
 warning3: "振替先アカウントを入力してください",
 warning4: "振替可能数量以下の数字を入力してください",
 gb: "閉じる",
 openSuccess: "先物取引利用可能になりました",
 openSuccessTip: "先物口座に資金を振替してください",
 warning5: "最大4桁の小数を保留できます",
 not_get_nm: "申し訳ありません、泥コードの配布は終了しました。今回の振替では泥コードを獲得できませんでした。",
  
};
export const invite = {
   yqfy: "招待コミッション",
 yj1: "招待リンク、招待ポスター、または紹介コードをシェア",
 yj2: "友達を招待して登録、取引を行う",
 yj3: "取引手数料のコミッションを受け取る",
 yqm: "私の招待コード：",
 yqlj: "私の招待リンク：",
 fz: "コピー",
 fzcg: "コピー成功",
 fzsb: "コピー失敗",
 dlck: "ログインして確認",
 rs: "招待した人数",
 ljbb: "累計現物取引コミッション({flag})",
 ljeft: "累計ETF取引コミッション({flag})",
 ljhy: "累計先物取引コミッション({flag})",
 yhm: "ユーザー名",
 sfsm: "本人確認済みであるかどうか",
 tjsj: "推薦時間",
 zsy: "総利益({flag})",
 s: "はい",
 f: "いいえ",
 djjz: "クリックしてもっと表示",
 ckmx: "詳細を表示",
 pm: "ランキング",
 zyqr: "月間招待数",
 zfyj: "月間コミッション額({flag})",
 ckbd: "全ランキングを表示",
 rlues1: "友達を招待して、長期的なコミッションを受け取りましょう。",
 rlues2: "友達を招待し、現物、ETF、先物取引を行うと、友達の取引手数料コミッションを受け取れます。招待コミッションの収益には上限はありません。",
 rlues3: "招待コミッションルール＆割合",
 jylx: "取引タイプ",
 yqrfy: "招待者コミッション",
 yqgxyxq: "招待関係有効期間",
 sixMonth: "6ヶ月",
 yj: "無期限",
 bbjy: "現物取引",
 hyjy: "先物取引",
 etfjy: "ETF取引",
 gxsj: "毎週月曜日にデータが更新されます",
 xts: "お知らせ",
 ts1: "友達が登録する際は、必ずあなたの紹介コードを入力するように伝えてください。これにより、友達を成功に招待したことになります！",
 ts2: "左側のQRコードをスキャンして、リンクをユーザーに転送することで、迅速にユーザーを招待できます。",
 tgzsy: "総合プロモーションコミッション額({flag})",
 cz: "操作",
 fymx: "コミッション明細 >",
 zwsj: "記録がありません",
 yh: "ユーザー",
 hqyj: "招待コミッションを受け取る",
 ysm: "本人確認済み",
 wsm: "本人確認待ち",
 hyfymx: "友達コミッション明細",
 fylx: "コミッションタイプ",
 fyje: "コミッション金額",
 fysj: "コミッション受取日",
 mxsyb: "利益明細表",
 zwjy: "この友達はまだ取引していないため、手数料コミッションはありません。",
 bczxc: "アルバムに保存",
 rlues4: "ネットワークの遅れにより、一部のユーザーはコミッションの受け取りに遅延が発生する可能性があります。ご了承ください。",
 moreRules: "詳細なルールを確認",
  
};

  



// WEBPACK FOOTER //
// ./src/i18n/lang/merchandiser/ja_JP.js